module.exports = __webpack_public_path__ + "static/media/logo-genesis-white-orange.c1667774.png";